/**
 * @fileoverview JS file for the Facebook introduction.
 *
 * The flow slider, add photos, template JS is in this file.
 *
 * @author Jamie Arkin (jarkin@yext.com)
 */
goog.provide('yext.storm.Introduction');
goog.provide('yext.storm.Match');

goog.require('yext');
goog.require('yext.gmb');
goog.require('yext.notify');
/** @suppress {extraRequire} */
goog.require('yext.plugins.contextualHelp');
goog.require('yext.plugins.ContextualHelpText');
/** @suppress {extraRequire} */
goog.require('yext.storm.LocationTooltip');
goog.require('yext.storm.routesDEPRECATED');

(function(window, document, undefined) {
  const toggleDisabled = function($el, disabled) {
    $el.toggleClass('btn-disabled', disabled);
    if (disabled && !$el.attr('disabled')) {
      $el.bind('click.disabled', function(e) {
        return false;
      });
      $el.attr('disabled', 'disabled');
    } else if (!disabled && $el.attr('disabled')) {
      $el.unbind('click.disabled');
      $el.removeAttr('disabled');
    }
  };

  /**
   * @constructor
   */
  const Introduction = function(options) {
    this.options = options || {};

    this.bindTermsOfService();
    //    this.bindOptOut();
    this.bindConnectActions();
    this.bindConnectAccount();
    this.bindCreateAccount();
    this.bindIncorrectLinkedAccount();
    this.initGMB();
    this.bindNextButtonEnablerFB();
    this.bindActivateFBSyncButton();
    this.bindFBConfirmButton();
  };

  /**
   * Binds oauthing action to a link
   * This will trigger a new popup with partner oathing information in it
   */
  yext.storm.Introduction.bindConnectAccount = function() {
    $('.connect-account-link').click(function(e) {
      e.preventDefault();
      const url = $(this).attr('data-url');
      const partnerId = $(this).attr('data-partner-id');
      let width = '400';
      let height = '400';
      if (partnerId === '558') { // GOOGLE+
        width = '640';
        height = '500';
      } else if (partnerId === '440') { // FOURSQUARE
        width = '960';
        height = '600';
      } else if (partnerId === '610') { // INSTAGRAM
        width = '640';
        height = '400';
      } else if (partnerId === '715') { // GMB
        width = '640';
        height = '500';
      }

      const authWindow = window.open(
        url, '_blank', 'resizable=yes,scrollbars=yes,width=' + width + ',height=' + height);
      if (!url) {
        const urlParams = yext.getUrlParams();
        // missing auth URL should be acquired via POST to issueAuthUrl
        const urlPromise = new Promise(function(resolve, reject) {
          $.ajax({
            type: 'POST',
            url: yext.storm.routesDEPRECATED.SocialIntro.issuePopupAuthUrl({
              authPartnerId: partnerId,
              locationId: urlParams['locationId'] ? urlParams['locationId'] : urlParams['entityId'],
            }),
            success: function(result) {
              resolve(result['popupAuthUrl']);
            },
            error: function() {
              reject();
            },
          });
        });
        urlPromise
          .then(url => {
            if (!url) {
              authWindow.close();
              yext.notify.showError(
                yext.msg('Our partner site is currently unavailable. Please try again later.'));
              return false;
            }
            authWindow.location = url;
          })
          .catch(() => {
            authWindow.close();
            yext.notify.showError(
              yext.msg('Something has gone wrong, please refresh and try again.'));
          });
      }
    });
  };

  goog.exportSymbol('Introduction', Introduction);

  Introduction.prototype.toggleDisabled = function($el, disabled) {
    toggleDisabled($el, disabled);
  };

  /**
   * Handle terms of service toggling.
   * Disables next/save button and a
   * contextual help dialog is replaced
   * when TOS is not checked.
   */
  Introduction.prototype.bindTermsOfService = function() {
    const $tos = $('#termsOfService');

    const toggleTOS = function() {
      const $btn = $('.fb-confirm, .link-fb-btn');
      const isChecked = $tos.is(':checked');

      toggleDisabled($btn, !isChecked);

      if (!isChecked) {
        $btn.contextualHelp();
      } else {
        $btn.unbind('.contextualHelp');
      }
    };

    if ($tos.length > 0) {
      $tos.change(toggleTOS);
      toggleTOS();
      yext.plugins.ContextualHelpText.Messages['fb-intro-disabled-msg'] = document.getElementById('fb-intro-fragment').innerHTML;
    }
  };

  /**
   * Allow the user to Opt out of a Location
   * for Facebook. Opt out dialog for multi
   * locations instead of link. The dialog
   * gives the option to opt out for
   * all or single locations.
   */
  Introduction.prototype.bindOptOut = function() {
    $('#opt-out-popup').dialog({
      width: 406,
      autoOpen: false,
      modal: true,
      open: function() {
        $('.cancel').bind('click', function() {
          $('#opt-out-popup').dialog('close');
        });
      },
    });

    // Opt out routes

    $('.opt-out').change(function() {
      $('#opt-out-submit').attr('href', $(this).data('href'));
    });

    $('#opt-out-link').click(function() {
      $('#opt-out-popup').dialog( 'open' );
    });

    const selected = $('#opt-out-options input[type=\'radio\']:checked');
    if (selected.length > 0) {
      $('#opt-out-submit').attr('href', selected.data('href'));
    }
  };

  /**
   * Initialize the photo view that is responsible
   * for uploading the cover or profile photo for
   * GoogleMyBusiness
   * @param {string} uploadUrl
   */
  Introduction.prototype.initGMB = function(uploadUrl) {
    if (yext.gmb.hasCoverPhotoSection()) {
      this.coverGmb = yext.gmb.newGoogleCoverPhotoView({uploadUrl: uploadUrl});
      $(this.coverGmb).on('error', function(e, message) {
        yext.notify.showError(message);
      });
    }

    if (yext.gmb.hasProfilePhotoSection()) {
      this.profileGmb = yext.gmb.newGoogleProfilePhotoView({uploadUrl: uploadUrl});
      $(this.profileGmb).on('error', function(e, message) {
        yext.notify.showError(message);
      });
    }
  };

  /**
   * Show/hide certain layout for
   * add photo temp for multi locations.
   * Allows users to select photos for
   * all or single locations.
   */
  Introduction.prototype.bindShowHidePhotoView = function() {
    const defaultSelected = $('#fb-view-dropdown').val();

    let uploadUrl;
    if (defaultSelected == 'business') {
      uploadUrl = '?allLocations=true&partnerId=715';
    } else {
      uploadUrl = '';
    }
    this.initGMB(uploadUrl);

    const hasGMBError = !($('.js-gmb-no-error').val());
    $('.graybox').toggle(false);
    $('.add-photo-title').toggle(false);
    $('.photo-'+ defaultSelected).toggle(true);
    $('#fb-view-dropdown').change(function() {
      const selected = $(this).val();
      $('.graybox').toggle(false);
      $('.add-photo-title').toggle(false);
      $('.photo-'+ selected).toggle(true);
      if (this.coverGmb != undefined) {
        if (selected == 'business') {
          this.coverGmb.options.uploadUrl = '?allLocations=true&partnerId=715';
        } else {
          this.coverGmb.options.uploadUrl = '';
        }
      }
      if (this.profileGmb != undefined) {
        if (selected == 'business') {
          this.profileGmb.options.uploadUrl = '?allLocations=true&partnerId=715';
        } else {
          this.profileGmb.options.uploadUrl = '';
        }
      }
      if (hasGMBError) {
        $('.js-gmb-error').toggle(false);
        $('.js-gmb-error-' + selected).toggle(true);
      }
    });
  };
  goog.exportProperty(
    Introduction.prototype,
    'bindShowHidePhotoView',
    Introduction.prototype.bindShowHidePhotoView);

  Introduction.prototype.bindConnectActions = function() {
    $('.social-intro-connect-actions').hover(function() {
      $(this).find('.hover-link').toggle();
    });
  };

  Introduction.prototype.bindConnectAccount = function() {
    yext.storm.Introduction.bindConnectAccount();
  };

  Introduction.prototype.bindCreateAccount = function() {
    if ($('.create-account-link').length) {
      $('.create-account-link').click(function(e) {
        e.preventDefault();
        const url = $(this).attr('data-url');
        window.open(url, '_blank', 'resizable=yes,scrollbars=yes,width=700,height=650');
      });
    }
  };


  Introduction.prototype.reload = function() {
    window.location.reload(true);
  };

  Introduction.prototype.closeCallback = function() {
    if (window.opener === null || !yext.isFunction(window.opener.Introduction)) {
      return;
    }

    window.opener.Introduction.prototype.reload();
    window.close();
  };
  goog.exportProperty(
    Introduction.prototype,
    'closeCallback',
    Introduction.prototype.closeCallback);

  /**
   * Adds error dialog when trying to link the wrong account.
   */
  Introduction.prototype.bindIncorrectLinkedAccount = function() {
    const $message = $('#incorrect-linked-account-dialog');
    if ($message) {
      const dialog = $message.dialog({
        draggable: false,
        modal: true,
        minWidth: 'auto',
      });
      dialog.find('.primary').click(function() {
        dialog.dialog('close');
        return false;
      });
      dialog.find('.primary').focus();
    }
  };

  /**
   * Disables or enables an element. Used for
   * the buttons for navigating to the next
   * connect steps.
   * @param {!jQuery} $el The element to toggle
   * @param {boolean} disabled True if disabling
   */
  Introduction.prototype.toggleDisabled = function($el, disabled) {
    $el.toggleClass('btn-disabled', disabled);
    if (disabled && !$el.attr('disabled')) {
      $el.on('click.disabled', function() {
        return false;
      });
      $el.attr('disabled', 'disabled');
    } else if (!disabled && $el.attr('disabled')) {
      $el.off('click.disabled');
      $el.removeAttr('disabled');
    }
  };

  /**
   * Determines whether or not our photo task
   * is complete for the page and then enables
   * the next button accordingly
   */
  Introduction.prototype.bindNextButtonEnablerFB = function() {
    if ($('.fb-content').length) {
      const self = this;
      const $innerContinue = $('.inner-continue-next');
      const $bottomContinue = $('.bottom-continue a');

      const $singleLoc = $('.fb-single-location');
      const $allLocs = $('.fb-all-locations');

      const facebookCheckRequired = function() {
        const allowEmptyPhotos = self.options['allowEmptyFacebookProfileAndCover'];
        const allLocsDisabled = $allLocs.find('.fb-no-picture').length !== 0;
        self.toggleDisabled($bottomContinue, allLocsDisabled && !allowEmptyPhotos);
        const singleLocDisabled = $singleLoc.find('.fb-no-picture').length !== 0;
        self.toggleDisabled($innerContinue, singleLocDisabled && !allowEmptyPhotos);
      };

      $('.js-facebook-photo-fields').on('photosUpdated', function() {
        facebookCheckRequired();
      });

      facebookCheckRequired();
    }
  };

  Introduction.prototype.bindActivateFBSyncButton = function() {
    const originalButtonClass = 'btn-orange';
    const activatingButtonClass = 'btn-darkgray btn-loading';
    const activatingButtonText = '<span> Activating <i class="icon-loading"> <i> </span>';
    const $successMessage = $('.js-fb-active-success-msg');
    const $buttonsContainer = $('.js-fb-button-container');
    const $syncButton = $('.js-active-facebook-sync');
    let redirectTimer;

    $syncButton.click(function(e) {
      if (!$(this).hasClass('disabled') && !$(this).hasClass('btn-disabled')) {
        e.preventDefault();

        if ($(this).hasClass('js-log-next')) {
          $.ajax({
            url: window.logRoutes.next,
            success: function(data) {
              if (data.url) {
                window.location.href = data.url;
              }
            },
          });
          return;
        }

        setActivatingState(this);

        window.setTimeout(function() {
          setSuccessState();
          redirectTimer = setInterval(function() {
            redirectCountdown();
          }, 1000);
        }, 1000);
      }
    });

    var redirectCountdown = function() {
      const $countdown = $('.js-timer-seconds');
      let currentTime = parseInt($countdown.html());
      currentTime = currentTime - 1;
      $countdown.html(currentTime);

      if (currentTime <= 0) {
        clearInterval(redirectTimer);
        triggerRedirect();
      }
    };

    var triggerRedirect = function() {
      let url = window.location.origin + $('.js-redirect-url').attr('href');
      if ($('#partner-redirect-url').length > 0) {
        url = $('#partner-redirect-url').val();
      }
      window.location = url;
    };

    var setActivatingState = function(button) {
      $(button).removeClass(originalButtonClass).html(activatingButtonText).addClass(activatingButtonClass);
    };

    var setSuccessState = function() {
      $buttonsContainer.hide();
      $successMessage.show();
      $('.progress-bar-4').removeClass('.progress-bar-4-3').addClass('.progress-bar-4-4');
    };
  };

  Introduction.prototype.bindFBConfirmButton = function() {
    const $confirmButton = $('.fb-confirm');
    const $emailInput = $('input[name="facebookEmail"]');

    const submit = function() {
      const href = $confirmButton.attr('href');
      const newHref =
        href +
        ($.inArray('?', href) >= 0 ? '&' : '?') +
        $emailInput.serialize() +
        '&agreedToTerms=' + $('#termsOfService').prop('checked');
      window.location = newHref;
    };

    if ($('.fb-email').length == 1) {
      $confirmButton.on('click', function(e) {
        if (!$confirmButton.attr('disabled')) {
          e.preventDefault();
          submit();
        }
      });
    }

    const toggleDisabled = function($el, disabled) {
      $el.toggleClass('btn-disabled', disabled);
      if (disabled && !$el.attr('disabled')) {
        $el.off('click');
        $el.on('click.disabled', function() {
          return false;
        });
        $el.attr('disabled', 'disabled');
      } else if (!disabled && $el.attr('disabled')) {
        $el.off('click.disabled');
        $el.on('click', function(e) {
          e.preventDefault();
          submit();
        });
        $el.removeAttr('disabled');
      }
    };

    const checkRequired = function() {
      const emailEmpty = $emailInput.val() == '';
      toggleDisabled($confirmButton, emailEmpty);
    };

    $emailInput.on('keyup', function() {
      checkRequired();
    });

    checkRequired();
  };

  /**
   * @constructor
   * A separate class for the match step. Stores data to populate dropdowns
   * and tooltips. Also handles when the continue button should be
   * enabled/disabled.
   *
   * @param {!Object} locationData - An object mapping partner IDs to a list
   *   of location objects, which contain their ID, name, and address.
   * @param {number} partnerId the partner id to submit
   * @param {number} goalId - The ID of the current goal in a
   *   LOG flow. Null if we're not currently in a LOG flow.
   * @param {number} locationId - the locationId of the location we are
   *   optimizing. Either one location or null for all applicable locations.
   */
  const Match = function(locationData, partnerId, goalId, locationId) {
    this.locationData = locationData;
    this.partnerId = partnerId;
    this.goalId = goalId;
    this.hasUnmatchedFacebookLocations = false;
    this.inLogFlow = goalId != null;
    this.tooltip = new yext.storm.LocationTooltip($('.location-tooltip'));
    this.locationId = locationId;


    // Different bindings are needed for the different scenarios
    if ( $('.no-managed-locations').length) {
      this.bindNoManagedLocation();
    } else if ($('.single-loc-manual-match').length) {
      this.bindSingleLocationManualMatch();
    } else if ($('.multi-loc-manual-match').length) {
      this.bindMultiLocationManualMatch();
      this.bindManualMatchContinue(goalId);
    } else if ($('.single-loc-single-page').length) {
      this.bindSingleLocationSinglePage();
    } else if ($('.single-loc-multi-page').length) {
      this.bindSingleLocationMultiplePages(goalId);
    } else if ($('.multi-loc-multi-page').length) { // Multiple Location, multiple pages
      this.bindMultipleLocationsMultiplePages();
      this.bindSelect();
      this.bindContinue(goalId);
    }

    this.bindTooltip();
  };
  goog.exportSymbol('Match', Match);

  /**
   * Submit the location map which will redirect the user to the next step
   *
   * @param locationMap Map of locations to managed locations
   * @param {number} goalId the current goal's ID (optional)
   */
  Match.prototype.submitLocationMap = function(locationMap, goalId) {
    const $form = $('.js-match-form');
    $form.find('input.js-match-location').val(yext.JSON.stringify(locationMap));
    $form.find('input.js-match-partner').val(this.partnerId);
    $form.find('input.js-match-goal').val(goalId ? goalId : this.goalId);
    $form.submit();
  };

  /**
   * Enables or disables the continue button. Also changes the button text
   * accordingly.
   */
  Match.prototype.checkContinue = function() {
    const $continueButton = $('.social-match-continue');
    const $buttonText = $continueButton.children('span');

    const numUnselected = $('option[value=""]:selected').length;
    const numDuplicates = $('.duplicate-location-error:visible').length;

    const disable = (numUnselected + numDuplicates) > 0;
    if (disable) {
      $buttonText.text(yext.msg('Continue'));
      toggleDisabled($continueButton, true);
    } else {
      if (!this.inLogFlow) {
        // LOG flow button should always say "Continue"
        if (this.hasUnmatchedFacebookLocations) {
          $buttonText.text(yext.msg('Continue to finish Facebook set up'));
        } else {
          $buttonText.text(yext.msg('Complete set up'));
        }
      }
      toggleDisabled($continueButton, false);
    }
  };

  const addUnMatchedLocationHtml = function(partnerId, $unmatchedLocations, numUnmatchedLocations) {
    let html = '';
    if (partnerId == 559) {
      html = yext.msgn('1 location needs additional setup. We\'ll finish this in the next step!',
        '{0} locations need additional setup. We\'ll finish those in the next step!',
        numUnmatchedLocations);
    } else if (partnerId == 558) {
      html = yext.msgn('<a class="unmatched-location-info">1 location</a> is not matched.  Before you can connect it you must first create and verify a page for it in your Google+ account.',
        '<a class="unmatched-location-info">{0} locations</a> are not matched.  Before you can connect them you must first create and verify pages for them in your Google+ account.',
        numUnmatchedLocations);
      html += ' <a href="https://support.google.com/plus/answer/2609871?rd=1" target="_blank">';
      html += yext.msg('Learn more about this.');
      html += '</a>';
    } else if (partnerId == 440) {
      html = yext.msgn('We\'ll set up a venue for your other location.',
        'We\'ll set up venue for your other {0} locations.',
        numUnmatchedLocations);
    }

    $unmatchedLocations
      .find('.unmatched-locations-text')
      .html(html)
      .end()
      .show();
  };

  /**
   * Checks the following and updates the page as necessary:
   *   - Duplicate selected locations error
   *   - Locations not selected
   *   - Enables/disables continue button
   */
  Match.prototype.selectUpdate = function() {
    const duplicateIds = [];
    const selectedIds = [];
    const $matchNetworkWrap = $('.social-intro-match-network');
    const partnerId = $matchNetworkWrap.attr('data-partner-id');
    const $continueButton = $('.social-match-continue');

    // Checks select values to determine selected locations and duplicate selections.
    // Shows duplicate selected location node.
    $matchNetworkWrap.find('.duplicate-location-error').hide();
    $matchNetworkWrap.find('select').each(function() {
      const val = $(this).val();
      if (val !== '' && val !== 'no-link') {
        if ($.inArray(val, selectedIds) === -1) {
          selectedIds.push(val);
        } else {
          if ($.inArray(val, duplicateIds) === -1) {
            $matchNetworkWrap.find('option[value="' + val + '"]:selected')
              .closest('.location-select')
              .find('.duplicate-location-error')
              .show();
            duplicateIds.push(val);
          }
        }
      }
    });

    // For g+, locations will be the unverified locations.
    const locations = this.locationData[partnerId];
    const unmatchedLocations = [];
    for (let i = 0; i < locations.length; i++) {
      if ($.inArray(locations[i]['id'], selectedIds) === -1) {
        unmatchedLocations.push(locations[i]);
      }
    }

    const numUnmatchedLocations = unmatchedLocations.length;
    const $unmatchedLocations = $matchNetworkWrap.find('.unmatched-locations');
    if (numUnmatchedLocations === 0) {
      $unmatchedLocations.hide();
      if (partnerId == 559) {
        this.hasUnmatchedFacebookLocations = false;
      }
    } else {
      addUnMatchedLocationHtml(partnerId, $unmatchedLocations, numUnmatchedLocations);
      if (partnerId == 559) {
        this.hasUnmatchedFacebookLocations = true;
      } else if (partnerId == 558) {
        $unmatchedLocations.find('.unmatched-location-info')
          .data('locations', unmatchedLocations);
      }
    }

    this.checkContinue();
  };

  /**
   * Binds actions when <select> elements are changed. Also updates the page
   * as described in selectUpdate based on the initial state.
   */
  Match.prototype.bindSelect = function() {
    const that = this;

    $('.location-selectify select').on('change', function() {
      that.selectUpdate();
    });

    // Initialize
    that.selectUpdate();
  };

  /**
   * Binds LocationTooltip to display appropriately.
   */
  Match.prototype.bindTooltip = function() {
    const that = this;
    $('.unmatched-locations').on('click', '.unmatched-location-info', function(e) {
      e.stopPropagation();
      const locations = $(this).data('locations');
      const $ul = $('<ul></ul>').addClass('tooltip-locations');
      for (let i = 0; i < locations.length; i++) {
        const location = locations[i];
        $('<li></li>')
          .append($('<div></div>')
            .addClass('tooltip-name')
            .text(location.name))
          .append($('<div></div>')
            .addClass('tooltip-address')
            .text(location.address))
          .appendTo($ul);
      }

      that.tooltip.setContent($ul);
      that.tooltip.show().position($(this));
    });
  };

  Match.prototype.bindContinue = function(goalId) {
    const self = this;

    $('.social-match-continue').click(function(e) {
      e.preventDefault();
      if ($(this).hasClass('btn-disabled')) {
        return;
      }

      const locationMap = [];
      $('.js-managed-location').each(function() {
        const $this = $(this);
        const partnerId = $this.attr('data-partner-id');
        const externalId = $this.attr('data-external-id');
        const locationId = $this.find('select').val();
        if (locationId !== 'no-link') {
          const entry = {
            'externalId': externalId,
            'locationId': locationId,
          };
          locationMap.push(entry);
        }
      });

      self.submitLocationMap(locationMap, goalId);
    });
  };

  /**
   * Binds events for buttons when in the single page single location scenario
   */
  Match.prototype.bindSingleLocationSinglePage = function() {
    const self = this;

    /**
     * User clicks 'No' so an empty request is submitted
     */
    $('.js-incorrect-managed-loc').click(function() {
      self.submitLocationMap([]);
    });

    /**
     * User clicks 'Yes' so submit locationMap for the one location and page avaliable
     */
    $('.js-correct-managed-loc').click(function() {
      const $this = $(this);
      const locationMap = [];

      locationMap.push({
        'externalId': $this.attr('data-external-id'),
        'locationId': $this.attr('data-location-id'),
      });

      self.submitLocationMap(locationMap);
    });
  };

  /**
  * User clicks next when the linked account doesn't manage any page. Next step should be create page
  */
  Match.prototype.bindNoManagedLocation = function() {
    const self = this;
    const $continueButton = $('.social-match-continue');

    toggleDisabled($continueButton, false);

    $continueButton.click(function(e) {
      e.preventDefault();
      self.submitLocationMap([]);
    });
  };

  /**
   * Method for events specific to the single location multiple pages sceneario
   */
  Match.prototype.bindSingleLocationMultiplePages = function() {
    const self = this;
    const $radioElements = $('.js-radio');
    const $continueButton = $('.social-match-continue');
    const $matchWrap = $('.js-single-loc-multi-page');
    const partnerId = $matchWrap.attr('data-partner-id');
    const locationId = $matchWrap.attr('data-location-id');

    /**
     * Enable continue button once a radio option has been selected
     */
    $radioElements.change(function() {
      toggleDisabled($continueButton, false);
    });

    /**
     * Bind event to when continue button is clicked that will build locationMap
     * and submit the data
     */
    $continueButton.click(function(e) {
      const externalId = $('.js-radio:checked').val();
      const locationMap = [];

      e.preventDefault();
      if ($continueButton.hasClass('btn-disabled')) {
        return;
      }

      if (externalId !== 'no-link') {
        locationMap.push({
          'externalId': externalId,
          'locationId': locationId,
        });
      }

      self.submitLocationMap(locationMap);
    });
  };

  /*
  * Method for events specific to single location manual match
  */
  Match.prototype.bindSingleLocationManualMatch = function(goalId) {
    const self = this;
    const $inputUrl = $('#single-loc-manual-text');
    const $matchWrap = $('.js-single-loc-manual-match');
    const partnerId = $matchWrap.data('partner-id');
    const linkedAccountId = $matchWrap.data('linked-account-id');
    const locationId = $matchWrap.data('location-id');
    const $errorUpdate = $('.js-single-loc-manual-error');
    const $loading = $('.js-icon-loading-single-loc');
    const $checkMark = $('.js-icon-checkmark-single-loc');
    const $continueButton = $('.social-match-continue');

    // Set the focus on the input when page loads
    $inputUrl.focus();

    function getExternalId() {
      const url = encodeURIComponent($inputUrl.val());
      if (!url) {
        return;
      }
      $loading.show();
      $.ajax({
        dataType: 'json',
        type: 'GET',
        url: window.extractExternalId({partnerId: partnerId, url: url, linkedAccountId: linkedAccountId}),
        success: function(result) {
          $loading.hide();
          if (result) {
            if (result.error) {
              $errorUpdate.text(result.error);
              $checkMark.hide();
              toggleDisabled($continueButton, true);
              $matchWrap.removeData('external-id');
            } else {
              $matchWrap.data('external-id', result.externalId);
              $checkMark.show();
              $errorUpdate.text('');
              toggleDisabled($continueButton, false);
            }
          } else {
            yext.notify.showError(yext.msg('Something has gone wrong, please refresh and try again.'));
          }
        },
        error: function(xhr) {
          // Only show error if the response object has headers. No headers present means the
          // request was ended early, e.g. a page redirect or reload
          if (xhr.getAllResponseHeaders() && xhr.getAllResponseHeaders() !== {}) {
            $matchWrap.removeData('external-id');
            yext.notify.showError(yext.msg('Something has gone wrong, please refresh and try again.'));
          }
        },
      });
    }

    // verify input url when input text loses focus
    $inputUrl.focusout(getExternalId);

    // verfiy input url when user stops typing for 0.5 second
    let timer;
    $inputUrl.keyup( function() {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(getExternalId, 500);
    });

    /*
    * When continue button is clicked, build locationMap and submit the data
    */
    $continueButton.click(function(e) {
      e.preventDefault();
      if ($continueButton.hasClass('btn-disabled')) {
        return;
      }
      const externalId = $matchWrap.data('external-id');
      const locationMap = [];
      if (externalId) {
        locationMap.push({
          'partnerId': partnerId,
          'externalId': externalId,
          'locationId': locationId,
        });
      }

      self.submitLocationMap(locationMap);
    });

    /* When user clicks skip */
    $('.js-skip-manual-match').click(function(e) {
      e.preventDefault();
      self.submitLocationMap([]);
    });
  };

  /*
  * Method for events specific to multiple location manual match
  */
  Match.prototype.bindMultiLocationManualMatch = function() {
    const self = this;
    let typingTimer = {};

    // Set focus on the first input
    $('.js-manual-match-url').first().focus();

    // bind all checkboxes
    $('.js-checkbox:checkbox').change( function() {
      self.manualMatchCheckboxUpdate($(this));
    });

    // bind all inputs when user stops typing for 0.5 second
    $('.js-manual-match-url').on('input propertyChange paste cut', function() {
      const $textBox = $(this);

      self.toggleMatchInProgress($textBox, true);

      self.checkAndClearTimer(typingTimer);

      typingTimer = setTimeout(function() {
        self.manualMatchUrlUpdate.call(self, $textBox);
      }, 200);
    });
  };

  /**
   * This checks to see if the timeout exists and clears it
   * @param  {!Object} timer a set timeout object
   */
  Match.prototype.checkAndClearTimer = function(timer) {
    if (timer) {
      clearTimeout(timer);
    }
  };

  /*
  * Method for verifying input URL through ajax call
  */
  Match.prototype.manualMatchUrlUpdate = function($textBox) {
    const self = this;
    const input = $textBox.val();
    const inputUrl = encodeURIComponent(input);

    // make sure the input is valid and at least is a facebook url
    if (!inputUrl || !yext.isValidUrl(input)) {
      // show the error message (this wipes a check mark if its already there)
      self.showMatchUrlError($textBox, yext.msg('Invalid URL'));
      return;
    }

    const $rowParent = $textBox.closest('.js-location-row');
    const $urlColumn = $rowParent.find('.js-url-column');
    const $errorUpdate = $rowParent.find('.js-manual-match-error');
    const partnerId = $rowParent.closest('.js-multi-loc-manual').data('partner-id');
    const linkedAccountId = $rowParent.find('.js-multi-loc-manual').data('linked-account-id');

    $.ajax({
      dataType: 'json',
      type: 'GET',
      url: window.extractExternalId({partnerId: partnerId, url: inputUrl, linkedAccountId: linkedAccountId}),
      success: function(result) {
        self.toggleMatchInProgress($textBox);

        if (result) {
          if (result.error) {
            self.showMatchUrlError($textBox, result.error);
            $urlColumn.removeData('external-id');
            manualMatchVerifyInput(self.locationData);
          } else {
            $urlColumn.data('external-id', result.externalId);
            self.showMatchUrlSuccess($textBox);
            manualMatchVerifyInput(self.locationData);
          }
        } else {
          yext.notify.showError(yext.msg('Something has gone wrong, please refresh and try again.'));
        }
      },
      error: function() {
        $urlColumn.removeData('external-id');
        yext.notify.showError(yext.msg('Something has gone wrong, please refresh and try again.'));
      },
    });
  };

  /**
   * Hide the checkmark if in progress,
   * shows the loading icon,
   * hides the checkmark and the error icon
   * @param  {!jQuery}  $textBox    textbox area to target
   * @param  {boolean} isInProgress [description]
   * @return {[type]}               [description]
   */
  Match.prototype.toggleMatchInProgress = function($textBox, isInProgress) {
    const $rowParent = $textBox.closest('.js-location-row');
    const $loading = $rowParent.find('.js-icon-loading-multi-loc');
    const $checkMark = $rowParent.find('.js-icon-checkmark-multi-loc');
    const $errorUpdate = $rowParent.find('.js-manual-match-error');

    $checkMark.hide(); // always want to disable the checkmark
    $errorUpdate.text(''); // always want to clear the error text
    $loading.toggle(isInProgress || false);
  };

  /**
   * Shows an Error Message next to the url input
   * @param {!jQuery} $textBox the textbox where the url error was input
   * @param {string} errorMsg a translated error string
   */
  Match.prototype.showMatchUrlError = function($textBox, errorMsg) {
    const $container = $textBox.closest('.js-location-row');
    const $errorUpdate = $container.find('.js-manual-match-error');

    this.toggleMatchInProgress($textBox);
    $errorUpdate.text(errorMsg);
  };

  /**
   * Shows a check mark next to the match url input
   * @param  {!jQuery} $textBox textbox where the match url was input
   */
  Match.prototype.showMatchUrlSuccess = function($textBox) {
    const $container = $textBox.closest('.js-location-row');
    const $checkMark = $container.find('.js-icon-checkmark-multi-loc');

    this.toggleMatchInProgress($textBox);
    $checkMark.show();
  };


  /*
  * Event handler for checkboxes on manual match page
  */
  Match.prototype.manualMatchCheckboxUpdate = function($checkBox) {
    const $textBox = $checkBox.closest('.js-url-column').find('.js-manual-match-url');

    if ($checkBox.is(':checked')) {
      $textBox.val('');
      $textBox.prop('disabled', true);
      const $urlColumn = $checkBox.closest('.js-url-column');
      $urlColumn.find('.js-manual-match-error').text('');
      $urlColumn.find('.js-icon-checkmark-multi-loc').hide();
      $urlColumn.removeData('external-id');
      manualMatchVerifyInput(this.locationData);
    } else {
      $textBox.prop('disabled', false);
      toggleDisabled($('.social-match-continue'), true);
      manualMatchVerifyInput(this.locationData);
    }
  };

  /*
  * Method for looping over all user input URL and checkbox and toggle continue button
  */
  var manualMatchVerifyInput = function(locationData) {
    const inputUrls = [];
    let allValidInputs = true;
    const unmatchedLocations = [];
    const partnerId = $('.js-multi-loc-manual').data('partner-id');
    const allLocations = locationData[partnerId];

    $('.js-url-column').each(function() {
      const $current = $(this);
      const url = $current.find('.js-manual-match-url').val().trim();

      if (!url) {
        if ($current.find('.js-checkbox').is(':checked')) {
          const locationId = $current.data('location-id');
          const result = $.grep(allLocations, function(e) {
            return e.id == locationId;
          });
          unmatchedLocations.push(result[0]);
        } else {
          allValidInputs = false;
        }
      } else {
        if ($.inArray(url, inputUrls) === -1) {
          inputUrls.push(url);
          // Also check if there's valid external id
          if (!$current.data('external-id')) {
            allValidInputs = false;
          } else {
            $current.find('.js-manual-match-error').text('');
            $current.find('.js-icon-checkmark-multi-loc').show();
          }
        } else {
          allValidInputs = false;
          $current.find('.js-manual-match-error').text(yext.msg('Duplicate URL provided'));
          $current.find('.js-icon-checkmark-multi-loc').hide();
        }
      }
    });

    const $continueButton = $('.social-match-continue');

    if (allValidInputs === true) {
      toggleDisabled($continueButton, false);
    } else {
      toggleDisabled($continueButton, true);
    }

    const $unmatchedLocationObject = $('.social-intro-match-network').find('.unmatched-locations');
    const numUnmatchedLocations = unmatchedLocations.length;
    if (numUnmatchedLocations === 0) {
      $unmatchedLocationObject.hide();
    } else {
      addUnMatchedLocationHtml(partnerId, $unmatchedLocationObject, numUnmatchedLocations);
      if (partnerId == 558) {
        $unmatchedLocationObject.find('.unmatched-location-info')
          .data('locations', unmatchedLocations);
      }
    }
  };

  /*
    * Method for binding manual match continue button
    */
  Match.prototype.bindManualMatchContinue = function(goalId) {
    const self = this;

    $('.social-match-continue').click(function(e) {
      e.preventDefault();
      if ($(this).hasClass('btn-disabled')) {
        return;
      }

      const locationMap = [];
      const $root = $('.js-multi-loc-manual');
      const partnerId = $root.data('partner-id');

      $('.js-url-column').each(function() {
        const $this = $(this);
        const externalId = $this.data('external-id');
        const locationId = $this.data('location-id');

        if (externalId) {
          const entry = {
            'partnerId': partnerId,
            'externalId': externalId,
            'locationId': locationId,
          };
          locationMap.push(entry);
        }
      });

      self.submitLocationMap(locationMap, goalId);
    });
  };

  /**
   * Method for events specific to the multiple location multiple pages scenario
   */
  Match.prototype.bindMultipleLocationsMultiplePages = function() {
    // Sets all unset location selectors to no-link
    $('.js-do-not-link-remaining').click(function() {
      $('.location-select select').each(function() {
        if (!this.value) {
          $(this).siblings('.selectify-options').find('li[data-value="no-link"]').click();
        }
      });
    });
  };
})(window, document);
